export default __webpack_public_path__ + "static/media/sidebar_stockout_gray.1c19d80f.svg";